<template>
  <div
    class="modal fade createNewModal"
    id="AddAnneeAcademiqueModal"
    tabindex="-1"
    ref="addAnneeAcademiqueModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="anneeForm" @submit="addAnneeAcademique" :validation-schema="anneeSchema">
            <div class="row">

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date Pré-rentrée <span class="text-danger">*</span>
                  </label>
                  <Field name="datePrerentree" type="date" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la date"/>
                  <ErrorMessage name="datePrerentree" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date Début <span class="text-danger">*</span>
                  </label>
                  <Field name="dateDebut" type="date" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la date"/>
                  <ErrorMessage name="dateDebut" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date Fin <span class="text-danger">*</span>
                  </label>
                  <Field name="dateFin" type="date" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la date"/>
                  <ErrorMessage name="dateFin" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Libellé <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libellé"/>
                  <ErrorMessage name="libelle" class="text-danger"/>
                </div>
              </div>
              
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { AnneeAcademique } from '../../models/AnneeAcademique';
import { error , success, hideModal } from '../../utils/utils';
import axios from 'axios';

export default defineComponent({
    name: "AddAnneeAcademiqueModal",
    components: {
    Form,
    Field,
    ErrorMessage,
   
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const anneeSchema = Yup.object().shape({
      datePrerentree: Yup.date()
        .required('La date de pré-rentrée est obligatoire')
        .typeError('Veuillez entrer une date valide')
        .max(
          Yup.ref('dateDebut'),
          'La date de rentrée doit être antérieure à la date de début'
        ),
       dateDebut: Yup.date()
        .required('La date de début est obligatoire')
        .typeError('Veuillez entrer une date valide'),
      dateFin: Yup.date()
        .required('La date de fin est obligatoire')
        .typeError('Veuillez entrer une date valide')
        .min(
          Yup.ref('dateDebut'),
          'La date de fin doit être postérieure à la date de début'
        ),
      libelle: Yup.string().required('Le libellé est obligatoire'),

    });

    const anneeForm = ref<AnneeAcademique | null>(null);
    const addAnneeAcademiqueModalRef = ref<null | HTMLElement>(null);
    
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter une année");
    const btntext = ref('Ajouter');
   

    watch(() => props.item, (newValue) => {
      getAnneeAcademique(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier l'année";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter une année";
         btntext.value = "Ajouter";
      }
    }

    const getAnneeAcademique = async (id: number) => {
      return ApiService.get("/annees/"+id)
      .then(({ data }) => {
        // map data in form
        const donnees = data.data;
        for (const key in donnees) {
          anneeForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addAnneeAcademiqueModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    onMounted(()=> {
      //fetchCommune();
    })

   

    const addAnneeAcademique = async (values: any, anneeForm) => {
      values = values as AnneeAcademique;
      if(isUPDATE.value){
        ApiService.put("/annees/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              anneeForm.resetForm();
              hideModal(addAnneeAcademiqueModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        ApiService.post("/annees",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              anneeForm.resetForm();
              hideModal(addAnneeAcademiqueModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { anneeSchema,
      addAnneeAcademiqueModalRef,
      addAnneeAcademique,
      anneeForm,
      title,btntext,resetValue
    };
  },
});
</script>